import { CustomBreadcrumbs } from './shareables/foundation/admin-ui/components/top-bar/breadcrumbs';

const customBreadcrumbs: CustomBreadcrumbs = [
	{
		match: 'transaction',
		replacement: undefined,
	},
];

export default customBreadcrumbs;
